import ApiService from './api.service';

class TicketService {
  async list() {
    try {
      const response = await ApiService.get('/ticket');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/ticket/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/ticket/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/ticket/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new TicketService(); 